<!--
 * @Description: 个别教育记录 详情
 * @Author: ztw
 * @Date: 2023-03-01 15:13:39.346
 * @LastEditors: 张天伟
 * @LastEditTime: 2023-03-01 22:00:29
-->
<template>
  <div>
    <el-dialog class="w800 h630" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <span class="header-title">详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-descriptions :column="2" border>
        <el-descriptions-item label="学期" label-align="right" align="left" width="120px" span="2">{{ruleForm.xqmc}}</el-descriptions-item>
        <el-descriptions-item label="学生" label-align="right" align="left" width="120px" span="2">{{ruleForm.xm}}</el-descriptions-item>
        <el-descriptions-item label="日期" label-align="right" align="left" width="120px" span="2">{{ruleForm.rq}}</el-descriptions-item>
        <el-descriptions-item label="教育情况" label-align="right" align="left" width="120px" span="2">{{ruleForm.jyqk}}</el-descriptions-item>
        <el-descriptions-item label="效果" label-align="right" align="left" width="120px" span="2">{{ruleForm.xg}}</el-descriptions-item>
      </el-descriptions>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="info" @click="closeWindow('openDetail', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { loadData, closeWindow } from '@/api/common.js'

const props = defineProps({
  openDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const ruleForm = ref({})
const emits = defineEmits(['update:openDetail'])

watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      loadData({
        url: '/api/v2/xuesheng/banzhurengongzuogebiejiaoyujilu/' + props.row.id,
        ruleForm
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
